import { render, staticRenderFns } from "./EditorSettings.vue?vue&type=template&id=03ab4b74"
import script from "./EditorSettings.vue?vue&type=script&lang=js"
export * from "./EditorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports